import { render, staticRenderFns } from "./BasicRadio.vue?vue&type=template&id=5490c688&scoped=true&"
import script from "./BasicRadio.vue?vue&type=script&lang=js&"
export * from "./BasicRadio.vue?vue&type=script&lang=js&"
import style0 from "./BasicRadio.vue?vue&type=style&index=0&id=5490c688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490c688",
  null
  
)

export default component.exports